import axios from '@/api/axios';
import qs from 'qs';
import * as s_Interface from '@/interface/store/inventory';
import { FilePayload, File, InsertDataPayload } from '@/interface/components';
import * as c_Interface from '@/interface/components/inventory';

export const getInventory = (
  groupId: string,
  attributes: string,
  limit: number,
  offset: number,
  order: string,
  include: string,
  filters: s_Interface.InventoryFilter,
  query: string
) => {
  const filterObject = {};
  for (let key in filters) {
    if (key === 'Locations') {
      Object.assign(filterObject, {
        fkLocationId: filters[key].mainArray,
        fkLocationSubId: filters[key].subArray,
      });
    } else {
      if (filters[key].subArray.length > 0) {
        switch (key) {
          case 'Types':
            Object.assign(filterObject, { fkTypeId: filters[key].subArray });
            break;
          case 'Vendors':
            Object.assign(filterObject, { fkVendorId: filters[key].subArray });
            break;
          case 'Manufacturers':
            Object.assign(filterObject, { fkManufacturerId: filters[key].subArray });
            break;
          case 'Users':
            Object.assign(filterObject, { ownedBy: filters[key].subArray });
            break;
        }
      }
    }
  }
  if (Object.keys(filterObject).length > 0) {
    const where = encodeURIComponent(qs.stringify(filterObject));
    return axios.get(
      `groups/${groupId}/inventory?limit=${limit}&offset=${offset}&order=${order}&where=${where}&query=${query}`
    );
  }
  return axios.get(
    `groups/${groupId}/inventory?limit=${limit}&offset=${offset}&order=${order}&query=${query}`
  );
};
export const setInventory = (groupId: string, payload: c_Interface.InventoryItemPayload) =>
  axios.post(`groups/${groupId}/inventory`, payload);
export const setInventoryBulk = (groupId: string, payload: s_Interface.InventoryItem) =>
  axios.post(`groups/${groupId}/inventory/bulk`, payload);
export const updateInventory = (
  groupId: string,
  inventoryId: string,
  payload: c_Interface.InventoryItemPayload
) => axios.put(`groups/${groupId}/inventory/${inventoryId}`, payload);
export const bulkUpdateInventory = (groupId: string, payload: s_Interface.InventoryItem) =>
  axios.put(`groups/${groupId}/inventory/bulk`, payload);
export const getInventoryItem = (groupId: string, inventoryId: string) =>
  axios.get(`groups/${groupId}/inventory/${inventoryId}`);
export const setAttachments = (
  groupId: string,
  inventoryId: string,
  payload: Array<InsertDataPayload>
) => axios.post(`groups/${groupId}/inventory/${inventoryId}/attachments`, payload);
export const getAttachments = (groupId: string, inventoryId: string) =>
  axios.get(`groups/${groupId}/inventory/${inventoryId}/attachments`);
export const deleteAttachment = (groupId: string, inventory: string, attachmentId: string) =>
  axios.delete(`groups/${groupId}/inventory/${inventory}/attachments/${attachmentId}`);
export const attachmentsInventorySignUrl = (
  groupId: string,
  inventoryId: string,
  payload: Array<FilePayload>
) => axios.post(`groups/${groupId}/inventory/${inventoryId}/attachments/sign`, payload);
export const attachmentsInventoryUpload = (url: string, file: File) =>
  axios.put(url, file, { headers: { 'Content-Type': file.type } });
export const deleteInventory = (groupId: string, inventoryId: string) =>
  axios.delete(`groups/${groupId}/inventory/${inventoryId}`);
export const bulkDeleteInventory = (groupId: string, payload: Array<string>) =>
  axios.delete(`groups/${groupId}/inventory/bulk`, { data: payload });
export const exportInventory = (groupId: string, startAt?: string, endAt?: string) => {
  if (startAt && endAt) {
    return axios.get(`groups/${groupId}/inventory/exports?startAt=${startAt}&endAt=${endAt}`);
  } else {
    return axios.get(`groups/${groupId}/inventory/exports`);
  }
};
export const getTemplateInventory = (groupId: string) =>
  axios.get(`groups/${groupId}/inventory/template`);
export const signUrlInventoryImport = (groupId: string, payload: FilePayload) =>
  axios.post(`groups/${groupId}/inventory/imports/sign`, payload);
export const inventoryImport = (url: string, file: File) =>
  axios.put(url, file, { headers: { 'Content-Type': file.type } });
export const importUpload = (groupId: string, payload: FilePayload) =>
  axios.post(`groups/${groupId}/inventory/imports`, payload);
export const getInventoryHistories = (groupId: string, inventoryId: string) =>
  axios.get(`groups/${groupId}/inventory/${inventoryId}/histories`);

export const getQueryParams = (groupId: string) =>
  axios.get(`groups/${groupId}/query-params?type=inventory`);
export const updateQueryParams = (groupId: string, payload: any) =>
  axios.put(`groups/${groupId}/query-params?type=inventory`, payload);
